import { useEffect, useState } from 'react';
import { shouldAttachHeaderClip } from './headerVideoPolicy.js';

/**
 * The hero stays still until the visitor requests playback. Reduced-motion
 * and save-data preferences keep the poster without loading the clip.
 */
export default function HeaderVideo() {
  const [mode, setMode] = useState('poster');

  useEffect(() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = Boolean(navigator.connection?.saveData);
    if (!shouldAttachHeaderClip({ reducedMotion, saveData })) return undefined;
    const id = requestAnimationFrame(() => setMode('ready'));
    return () => cancelAnimationFrame(id);
  }, []);

  const frame = 'absolute inset-0 h-full w-full object-cover';
  const position = { objectPosition: 'center right' };

  return (
    <>
      {mode === 'video' ? (
        <video
          className={frame}
          style={position}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster="/rebuild/images/ship-aerial.webp"
          aria-hidden="true"
        >
          <source src="/rebuild/video/header-loop-ship.mp4" type="video/mp4" />
        </video>
      ) : (
        <img
          src="/rebuild/images/ship-aerial.webp"
          alt=""
          className={frame}
          style={position}
          width="1600"
          height="900"
          fetchPriority="high"
          decoding="async"
        />
      )}
      {mode !== 'poster' && (
        <button
          type="button"
          className="btn-secondary absolute bottom-6 right-6 z-10 text-sm"
          onClick={() => setMode((current) => current === 'video' ? 'ready' : 'video')}
        >
          {mode === 'video' ? 'Stop background video' : 'Play background video'}
        </button>
      )}
    </>
  );
}
